var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 85.434 45.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21016",
    "data-name": "Group 21016",
    transform: "translate(-144 -768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21007",
    "data-name": "Group 21007",
    transform: "translate(144 768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36774",
    "data-name": "Path 36774",
    d: "M148.708,225.336a7.05,7.05,0,1,1-7.05-7.028A6.941,6.941,0,0,1,148.708,225.336Zm-3.086,0a3.974,3.974,0,1,0-3.964,4.258A4.047,4.047,0,0,0,145.621,225.336Z",
    transform: "translate(-112.147 -210.536)",
    fill: "#ff4131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36775",
    "data-name": "Path 36775",
    d: "M239.852,225.336a7.05,7.05,0,1,1-7.05-7.028A6.941,6.941,0,0,1,239.852,225.336Zm-3.086,0a3.974,3.974,0,1,0-3.964,4.258A4.047,4.047,0,0,0,236.766,225.336Z",
    transform: "translate(-188.082 -210.536)",
    fill: "#ffbc00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36776",
    "data-name": "Path 36776",
    d: "M330.33,218.733v12.617c0,5.19-3.061,7.31-6.679,7.31a6.692,6.692,0,0,1-6.229-4.141l2.687-1.118a3.882,3.882,0,0,0,3.539,2.494c2.316,0,3.751-1.429,3.751-4.119v-1.011h-.108a4.785,4.785,0,0,1-3.7,1.6,7.032,7.032,0,0,1,0-14.052,4.87,4.87,0,0,1,3.7,1.572h.108v-1.144h2.931Zm-2.712,6.628c0-2.475-1.651-4.284-3.751-4.284a4.274,4.274,0,0,0,0,8.517A3.927,3.927,0,0,0,327.618,225.361Z",
    transform: "translate(-263.986 -210.536)",
    fill: "#0085f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36777",
    "data-name": "Path 36777",
    d: "M411.524,176.534v20.595h-3.01V176.534Z",
    transform: "translate(-340.348 -175.732)",
    fill: "#00a94b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36778",
    "data-name": "Path 36778",
    d: "M444.753,227.633l2.4,1.6a7,7,0,0,1-5.855,3.114,6.876,6.876,0,0,1-6.974-7.028,6.678,6.678,0,0,1,6.628-7.028,6.527,6.527,0,0,1,6.014,4.471l.32.8-9.394,3.891a3.576,3.576,0,0,0,3.406,2.129,4.011,4.011,0,0,0,3.46-1.945ZM437.38,225.1l6.28-2.608a2.721,2.721,0,0,0-2.608-1.489A3.855,3.855,0,0,0,437.38,225.1Z",
    transform: "translate(-361.847 -210.52)",
    fill: "#ff4131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36779",
    "data-name": "Path 36779",
    d: "M11.067,184.7V181.72H21.115a10.753,10.753,0,0,1-2.433,8.773,9.978,9.978,0,0,1-7.611,3.061,10.913,10.913,0,1,1,0-21.824,10.4,10.4,0,0,1,7.477,3.007l-2.1,2.1a7.6,7.6,0,0,0-5.377-2.129,7.931,7.931,0,0,0,0,15.861,7.3,7.3,0,0,0,5.51-2.183,6.179,6.179,0,0,0,1.616-3.691Z",
    transform: "translate(0 -171.73)",
    fill: "#0085f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21015",
    "data-name": "Group 21015",
    transform: "translate(144 801.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21010",
    "data-name": "Group 21010",
    transform: "translate(72.928 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#ececec",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#fbbc04",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21014",
    "data-name": "Group 21014",
    transform: "translate(54.696 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-2",
    "data-name": "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008-2",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780-2",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#fbbc04",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_2",
    "data-name": "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009-2",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781-2",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#fbbc04",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21011",
    "data-name": "Group 21011",
    transform: "translate(36.464 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-3",
    "data-name": "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008-3",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780-3",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#fbbc04",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_3",
    "data-name": "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009-3",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781-3",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#fbbc04",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21012",
    "data-name": "Group 21012",
    transform: "translate(18.232 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-4",
    "data-name": "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008-4",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780-4",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#fbbc04",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_4",
    "data-name": "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009-4",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781-4",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#fbbc04",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21013",
    "data-name": "Group 21013",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star-5",
    "data-name": "Star",
    transform: "translate(6.161 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21008-5",
    "data-name": "Group 21008",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36780-5",
    "data-name": "Path 36780",
    d: "M38.3,4.493a.7.7,0,0,0-.54-.473L34.3,3.371,32.6.358A.705.705,0,0,0,31.988,0h0V10.364l3.188,1.464a.71.71,0,0,0,.712-.07.7.7,0,0,0,.283-.653L35.736,7.7l2.4-2.508a.7.7,0,0,0,.16-.7Z",
    transform: "translate(-31.985 0)",
    fill: "#fbbc04",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star_1_5",
    "data-name": "Star_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21009-5",
    "data-name": "Group 21009",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36781-5",
    "data-name": "Path 36781",
    d: "M6.345,0h0a.705.705,0,0,0-.615.358l-1.7,3.012-3.456.65a.7.7,0,0,0-.54.473.7.7,0,0,0,.16.7L2.6,7.7l-.435,3.407a.7.7,0,0,0,.283.653.71.71,0,0,0,.712.07l3.188-1.464Z",
    transform: "translate(-0.002 -0.001)",
    fill: "#fbbc04",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7835cdfb7bf34c2bbc5557a10e9de594.svg";
export { ForwardRef as ReactComponent };